// ─────────────────────────────────────────────────────────────────────────────
// useColumnAlign, ports CD's presentational seam-alignment script (the inline
// <script> at the bottom of dashboard.html) into a React effect. It nudges two
// rail heights so the desktop two-column layout lines up: the Opportunities
// scroll ends on the Biggest-movers line, and Upcoming's top matches the
// Most-recent-release top. Skips when the layout has collapsed to one column.
// Verbatim port of CD's align() logic.
// ─────────────────────────────────────────────────────────────────────────────

import { useEffect } from 'react';

export function useColumnAlign(active: boolean): void {
  useEffect(() => {
    if (!active) return;

    function align(): void {
      const q = (s: string): HTMLElement | null => document.querySelector(s);
      const spot = q('#spotlight-card');
      const movers = q('.movers');
      const opps = q('#opportunities-card');
      const scroll = q('.opp-scroll');
      const merch = q('#merch-summary-card');
      const upcoming = q('#upcoming-shows-card');
      const release = q('#label-recent-release');
      if (!spot || !movers || !opps || !scroll || !merch || !upcoming || !release) return;
      scroll.style.maxHeight = '';
      merch.style.marginBottom = '';
      // Skip when the layout has collapsed to a single column.
      if (Math.abs(opps.getBoundingClientRect().top - spot.getBoundingClientRect().top) > 2) return;
      const oppsRect = opps.getBoundingClientRect();
      const chrome = oppsRect.height - scroll.getBoundingClientRect().height;
      const targetH = Math.round(movers.getBoundingClientRect().top - oppsRect.top - chrome);
      if (targetH > 140) scroll.style.maxHeight = targetH + 'px';
      const delta = Math.round(release.getBoundingClientRect().top - upcoming.getBoundingClientRect().top);
      if (delta > 0) merch.style.marginBottom = delta + 'px';
    }

    const onResize = (): void => {
      requestAnimationFrame(align);
    };

    window.addEventListener('resize', onResize);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(align);
    align();

    return () => {
      window.removeEventListener('resize', onResize);
    };
  });
}
